import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforAcceptPacket {
    checked_NeedWeight:Boolean
    checked_Voice: Boolean
    checked_GetOrderDestnationOrg: Boolean
    checked_OverWeightPromot: Boolean
    putInWeightLock: Boolean
}

@Module({ dynamic: true, store, name: 'store_scanforacceptpacket' })
class ScanforAcceptPacket extends VuexModule implements IScanforAcceptPacket {

    public checked_NeedWeight = false;
    public checked_Voice = false;
    public checked_GetOrderDestnationOrg = false;
    public checked_OverWeightPromot = false;
    public QueryTimeTypesList=[];
    public putInWeightLock = false;
    //不校验重复扫描开关值
    public checked_NoCheckReScan = false;
    public isSortingByWeightRange = false;   // 重量段分拣标识
    @Mutation
    public PutInWeightLockChangeState(state) {
        this.putInWeightLock = state;
    }

    @Mutation
    public NeedWeightChangeState(state) {
        this.checked_NeedWeight = state;
    }

    @Mutation
    public VoiceChangeState(state) {
        this.checked_Voice = state;
    }
    @Mutation
    public GetOrderDestnationOrgChangeState(state) {
        this.checked_GetOrderDestnationOrg = state;
    }
    @Mutation
    public OverWeightPromotChangeState(state) {
        this.checked_OverWeightPromot = state;
    }

    @Mutation
    public QueryTimeTypesListSet(timeTypesList) {
        this.QueryTimeTypesList = timeTypesList;
    }

    @Mutation
    public SetIsSortingByWeightRange(isSortingByWeightRange) {
      this.isSortingByWeightRange = isSortingByWeightRange
    }

  @Mutation
  public NoCheckReScanState(state)
  {
    this.checked_NoCheckReScan = state;
  }


    // @Action
    // public async GetUserInfo() {
    //     const name = "data.user";
    // }

}

export const ScanforAcceptPacketModule = getModule(ScanforAcceptPacket)
